<template src="./Details.html">
</template>

<script>
export default {
        props: {
            itemId: {
                type: Number,
                required: true,
            },
        },

        created() {
            this.$store.dispatch("users/getDetails", this.itemId);

        },
  computed: {
    user() {
    return this.$store.state.users.user;
  },
  },
};
</script>